import { render } from "./SolicitudesPendientes.vue?vue&type=template&id=f5ebd7cc"
import script from "./SolicitudesPendientes.vue?vue&type=script&lang=js"
export * from "./SolicitudesPendientes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__